import './App.css';
import Home from '../src/Components/Home/Home'
import Reviews from '../src/Components/Reviews/Reviews'
import Blogs from '../src/Components/Blogs/Blogs'
import About from '../src/Components/About/About'
import NotFound from '../src/Components/NotFound/NotFound'
import DashBoard from '../src/Components/DashBoard/DashBoard'
import { Route, Routes } from 'react-router-dom';
import Header from './Components/Header/Header';

function App() {
  return (
    <div>
      <Header></Header>
    <Routes>
      <Route path='/' element={<Home></Home>}></Route>
      <Route path='/home' element={<Home></Home>}></Route>
      <Route path='/reviews' element={<Reviews></Reviews>}></Route>
      <Route path='/dashboard' element={ <DashBoard></DashBoard> }></Route>
      <Route path='/blogs' element={ <Blogs></Blogs>}></Route>
      <Route path='/about' element={<About></About>}></Route>
      <Route path='*' element={ <NotFound></NotFound> }></Route>
    </Routes>
    </div>
  );
}

export default App;
